import { render, staticRenderFns } from "./LiabilityMortgageEstatePlanning.vue?vue&type=template&id=9b265b56"
import script from "./LiabilityMortgageEstatePlanning.vue?vue&type=script&lang=js"
export * from "./LiabilityMortgageEstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports